import React from 'react';
import { Link } from 'react-router-dom';
import { useWebsiteContent } from './WebsiteContentContext';

export const Footer = () => {
  const { footer_tagline, contact_email } = useWebsiteContent();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="marketing-footer" className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Link to="/" className="inline-flex items-center">
            <img src="/marketing/brand/logoMainWhite.png" alt="Rate My Service" className="h-12 w-auto object-contain" />
          </Link>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
            {footer_tagline}
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Product</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-white transition">Home</Link></li>
            <li><Link to="/about" className="hover:text-white transition">How it works</Link></li>
            <li><Link to="/packages" className="hover:text-white transition">Pricing</Link></li>
            <li><Link to="/register" className="hover:text-white transition">Start free trial</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/contact" className="hover:text-white transition">Contact us</Link></li>
            <li><a href={`mailto:${contact_email}`} className="hover:text-white transition">{contact_email}</a></li>
            <li><Link to="/login" className="hover:text-white transition">Sign in</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {year} Rate My Service. All rights reserved.</p>
          <p>Built for teams who care about every customer.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
